export default __webpack_public_path__ + "static/media/alamo-note.b303edd8.webp";